import { heroiconPaths, iconAliases } from './heroicon-paths';

export type IconName = keyof typeof iconAliases;

/** One labelled-at-the-control icon vocabulary; paths are licensed source assets. */
export function Icon({ name, className = '' }: { name: IconName; className?: string }) {
  return (
    <svg aria-hidden="true" focusable="false" className={'icon ' + className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8">
      {heroiconPaths[iconAliases[name]].map((path, index) => <path key={index} d={path} />)}
    </svg>
  );
}
